import { Loader2Icon } from 'lucide-react';
import { Link, useParams } from 'react-router';

import { Button } from '@/components/ui/button';
import { TicketDetailView } from '@/products/helpdesk/features/tickets/ticket-detail-view';
import { useAppPaths } from '@/products/helpdesk/features/portal/portal-paths';
import {
  useTicket,
  useTicketAttachments,
  useTicketComments,
  useTicketHistory,
  useTicketLookups,
} from '@/products/helpdesk/features/tickets/use-tickets';
import { usePageTitle } from '@/hooks/use-page-title';
import { ApiRequestError } from '@/lib/api';

export function TicketDetailPage() {
  const { ticketRef } = useParams<{ ticketRef: string }>();
  const ticket = useTicket(ticketRef);
  useTicketComments(ticketRef);
  useTicketHistory(ticketRef);
  useTicketAttachments(ticketRef);
  useTicketLookups();
  const paths = useAppPaths();
  const title = ticket.data
    ? paths.isPortal
      ? `Anfrage #${ticket.data.number}`
      : `Ticket #${ticket.data.number}`
    : ticket.isError
      ? paths.isPortal
        ? 'Anfrage nicht gefunden'
        : 'Ticket nicht gefunden'
      : paths.isPortal
        ? 'Anfrage'
        : 'Ticket';
  usePageTitle(title);

  if (ticket.isPending) {
    return (
      <p className="flex items-center gap-2 text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        Ticket wird geladen …
      </p>
    );
  }

  if (ticket.isError || !ticket.data) {
    return (
      <section className="space-y-3">
        <h1 className="text-2xl font-bold">
          {paths.isPortal ? 'Anfrage nicht gefunden' : 'Ticket nicht gefunden'}
        </h1>
        <p className="text-muted-foreground">
          {ticket.error instanceof ApiRequestError
            ? ticket.error.message
            : 'Das Ticket konnte nicht geladen werden.'}
        </p>
        <Button asChild variant="outline">
          <Link to={paths.tickets}>
            {paths.isPortal ? 'Zurück zu meinen Anfragen' : 'Zurück zur Übersicht'}
          </Link>
        </Button>
      </section>
    );
  }

  return <TicketDetailView key={ticket.data.id} ticket={ticket.data} />;
}
